import { gql } from '@apollo/client';

export const GET_PAGE_MAP_AREAS = gql`
query getPageMapAreas ($input: PageUrltagInput!) {
  getPageMapAreas(input: $input) {
    count
    list {
      id
      name
    }
  }
}`;